<div class="alerts">
  <div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alerts__alert" [@alertTransition]="'in'">
    {{alert.message}}
    <a class="alerts__alert__close" (click)="removeAlert(alert)"><span class="ico-remove"></span></a>
    <div [style.width.%]="alert.progress" class="alerts__alert__progress"></div>
  </div>
</div>